/* ============================================================
   IDEAS CAFE — <ideas-related>

   Fetches its OWN section against the product recommendations
   endpoint. `recommendations` is only populated on a request to that
   endpoint, so the section paints empty and this fills it in.

   Re-requesting the same section id is deliberate: it means the
   fetched markup is rendered by the same Liquid, with the same
   settings, so the card height, columns and add control configured in
   the theme editor all apply — and prices are formatted by the server,
   which matters for PKR.
   ============================================================ */
(function () {
  'use strict';

  if (customElements.get('ideas-related')) return;

  class IdeasRelated extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url || this.dataset.loaded === 'true') return;

      // Once only. Section Rendering returns this same element, so
      // without the flag the injected copy would fetch again.
      this.dataset.loaded = 'true';

      var self = this;
      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('Related products failed: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('ideas-related');

          // Nothing to recommend: stay hidden rather than leave a
          // heading with an empty row under it.
          if (!fresh || !fresh.querySelector('[data-rel-track]')) return;

          self.innerHTML = fresh.innerHTML;
          self.hidden = false;
          self._bind();
        })
        .catch(function (err) {
          console.warn('[ideas] related products failed', err);
        });
    }

    _bind() {
      var track = this.querySelector('[data-rel-track]');
      if (!track) return;

      var self = this;

      this.addEventListener('click', function (event) {
        var prev = event.target.closest('[data-rel-prev]');
        var next = event.target.closest('[data-rel-next]');
        if (!prev && !next) return;

        event.preventDefault();
        // A card plus its gap, so a press lands on a card edge rather
        // than an arbitrary offset.
        var card = track.firstElementChild;
        var step = card ? card.offsetWidth + 16 : track.clientWidth;
        track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        self._updateArrows();
      });

      window.addEventListener('resize', function () {
        self._updateArrows();
      });

      this._updateArrows();
    }

    // Disable an arrow at the end of its travel rather than leave a
    // control that silently does nothing.
    _updateArrows() {
      var track = this.querySelector('[data-rel-track]');
      var prev = this.querySelector('[data-rel-prev]');
      var next = this.querySelector('[data-rel-next]');
      if (!track || !prev || !next) return;

      var max = track.scrollWidth - track.clientWidth;

      // Nothing overflows, so the arrows have nothing to do.
      if (max <= 1) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }

      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }
  }

  customElements.define('ideas-related', IdeasRelated);
})();
